import api from "./axios";

// 문서 업로드 (신규 생성)
export const uploadDesignDoc = (formData) => {
  return api.post("/design/docs/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// 문서 상세 조회
export const getDesignDocDetail = (docId) => api.get(`/design/docs/${docId}/`);

// 문서 버전 업로드
export const uploadDesignDocVersion = (docId, formData) =>
  api.post(`/design/docs/${docId}/upload_version/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
// 폴더 트리 조회
export const getDesignFolderTree = () => api.get("/design/folders/tree/");

// 폴더 생성
export const createDesignFolder = (data) =>
  api.post("/design/folders/tree/", data);

// 폴더 삭제
export const deleteDesignFolder = (folderId) =>
  api.delete(`/design/folders/${folderId}/`);

// DWG → PDF 변환 요청
// export const convertDesignDocToPDF = (docId) =>
//   api.post(`/design/docs/${docId}/convert_pdf/`);

// 도면 검토

// 도면 검토 요청 목록 조회
export const getDesignReviewRequests = () =>
  api.get(`/design/design_requests/`);

// 도면 검토 요청 상세 조회
export const getDesignReviewRequest = (id) =>
  api.get(`/design/design_requests/${id}/`);

// 도면 검토 요청 등록
export const createDesignReviewRequest = (formData) =>
  api.post("/design/design_requests/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
